/**
 * @spec docs/specs/features/staking-ui-batched-reads.md (R8 metadata)
 *
 * Symbol and decimals of every balance the app reads. These are constants of the deployed
 * contracts, so they are never read over RPC (no `symbol()` / `decimals()` calls). Kept free of
 * address requirements so any module can import it; lib/tokens.ts builds its send registry on it.
 */
import { env } from './env';
import type { BalanceAsset } from './read-api';

export interface AssetMetadata {
  readonly symbol: string;
  readonly decimals: number;
}

export const ASSET_METADATA: Readonly<Record<BalanceAsset, AssetMetadata>> = {
  phnm: { symbol: 'PHNM', decimals: 18 },
  usdc: { symbol: 'USDC', decimals: 6 },
  chip: { symbol: 'CHIP', decimals: 6 },
  eth: { symbol: 'ETH', decimals: 18 },
  // Dev/testnet may use 18 decimals for USDT, production uses 6.
  usdt: { symbol: 'USDT', decimals: env.usdtDecimals },
  pol: { symbol: 'POL', decimals: 18 },
};
